export default __webpack_public_path__ + "static/media/pr3.6659239a.png";